// extracted by mini-css-extract-plugin
export var darkMode = "_o-0";